import { dateFormatEn } from '@/configs/dateFormat';
import { useSetting } from '@/contexts/CompanyContext';
import { IOrder } from '@/interfaces/order';
import { getFullAddress } from '@/utils/customerUtils';
import { formatDate } from '@/utils/dataUtils';
import React from 'react';

interface IProps {
  titleEn: string;
  code: string;
  data: IOrder;
}

const TemplateOrderInfoExport = ({ data }: IProps) => {
  const { setting } = useSetting();
  return (
    <div className="flex flex-row gap-5 mb-8">
      <div className="basis-1/2">
        <p className="font-bold mb-1 bg-gray-300 text-black px-1 inline-block">
          SHIPPER
        </p>
        <p className="font-bold  text-xs">{setting?.companyNameEn}</p>
        <p className="text-xs max-w-[250px]">
          {setting?.companyAddressBillingEn}
        </p>
      </div>
      <div className="basis-1/2">
        <p className="font-bold mb-1 bg-gray-300 text-black, px-1 inline-block">
          CONSIGNEE
        </p>
        <p className="font-bold  text-xs">{data?.customer?.name}</p>
        <p className="max-w-[250px] text-xs">
          {getFullAddress(data?.customer) || ''}
        </p>
        <p className="max-w-[250px] text-xs">
          ATTN : {data?.shippingAddress?.contactName || '-'}
        </p>
        <p className="max-w-[250px] text-xs">
          Tel.: {data?.shippingAddress?.phoneNumber || '-'}
        </p>
        <p className="max-w-[250px] text-xs">
          Email: {data?.shippingAddress?.email || '-'}
        </p>
      </div>
      <div className="basis-1/3 text-xs">
        <div className="flex flex-row justify-between mb-0.5">
          <div className="font-bold">INVOICE NO.: </div>
          <div>{data?.ivNo || '-'}</div>
        </div>
        <div className="flex flex-row justify-between text-xs mb-2">
          <div className="font-bold">DATE :</div>
          <div>{formatDate(data?.orderDate, dateFormatEn, 'en')}</div>
        </div>
        <div className="flex flex-row justify-between  mb-0.5">
          <div className="font-bold">PO NO.:</div>
          <div>{data?.poNo || '-'}</div>
        </div>
        <div className="flex flex-row justify-between  mb-2">
          <div className="font-bold">PO Date :</div>
          <div>
            {(data?.poDate && formatDate(data?.poDate, dateFormatEn, 'en')) ||
              '-'}
          </div>
        </div>
        <div className="flex flex-row justify-between  mb-0.5">
          <div className="font-bold">INV REF.:</div>
          <div>{data?.refIvCode || '-'}</div>
        </div>
        <div className="flex flex-row justify-between  mb-2">
          <div className="font-bold">CO REF.:</div>
          <div>{data?.soNo || '-'}</div>
        </div>
      </div>
    </div>
  );
};

export default TemplateOrderInfoExport;
